export default "__VITE_ASSET__DIuT_8Sc__"